import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import {
  fetchMonthlyCRStats,
  downloadCsv,
  MonthlyCRStatsResponse,
} from '~/services/predefinedReports';
import { PredefinedTreeLayout } from './PredefinedTreeLayout';

const MonthlyCRStatsResults: React.FC = () => {
  const [searchParams] = useSearchParams();
  const [data, setData] = useState<MonthlyCRStatsResponse | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const params = {
      from_date: searchParams.get('from_date') || undefined,
      to_date: searchParams.get('to_date') || undefined,
    };
    setLoading(true);
    fetchMonthlyCRStats(params)
      .then((d) => { setData(d); setError(null); })
      .catch((e) => { setError(e.message); setData(null); })
      .finally(() => setLoading(false));
  }, [searchParams]);

  const subtitle = data ? `${data.from_date} to ${data.to_date}` : undefined;
  const callout = data
    ? { label: 'Net actionable CRs added to Backlog', count: data.net_actionable_added }
    : undefined;

  return (
    <PredefinedTreeLayout
      title='Monthly Campaign Request Stats'
      subtitle={subtitle}
      sections={data?.sections ?? []}
      callout={callout}
      loading={loading}
      error={error}
      onDownloadCsv={() => downloadCsv('monthly-cr-stats', searchParams)}
    />
  );
};

export default MonthlyCRStatsResults;
